export const selectOptionsEntityType = [
  "LLC",
  "S-Corp",
  "Revocable Trust",
  "Irrecovable Trust",
  "TBD",
];
